import { ModalForm, ProFormTextArea } from '@ant-design/pro-components'

export default function ({ data, visible, onVisibleChange }) {
  return <ModalForm
    readonly
    title='订单备注'
    layout='vertical'
    open={visible}
    modalProps={{
      centered: true,
      maskClosable: false,
      destroyOnClose: true
    }}
    submitter={{
      searchConfig: {
        resetText: '关闭'
      },
      submitButtonProps: {
        style: {
          display: 'none'
        }
      },
    }}
    request={async () => data}
    onOpenChange={onVisibleChange}
  >
    <ProFormTextArea
      name='remark'
      label='订单备注'
      fieldProps={{ rows: 6 }}
      rules={[ { required: true, message: '请输入订单备注' } ]}
    />
  </ModalForm>
}
